export default {
    keyword_redirection : "Redirection based on keyword", // id 9
    api : "Api Call",// id 8
    condition : "Condition", // id 7
    extract_data : "Extract information from a variable", // id 6
    set_var : "Set a variable Value", // id 5
    default : "Select an action"
}